import { GetEtiquetaByIdDtoProps } from "./DTOs/GetEtiquetaByIdDto"
import { GetAllEtiquetasDtoProps } from "./Schemas/GetAllEtiquetasDto"

export const etiquetaDTOAdapter = (categoria: GetAllEtiquetasDtoProps) => ({
  cuentaContableId: categoria?.cuentaContableId,
  id: categoria?.id,
  icono: categoria?.icono,
  nombre: categoria?.nombre,
})

export const etiquetaByIdAdapter = (
  categoria: GetEtiquetaByIdDtoProps
): GetEtiquetaByIdDtoProps => ({
  id: categoria?.id,
  icono: categoria?.icono,
  nombre: categoria?.nombre,
  cuentaContableId: categoria?.cuentaContableId,
  empresaId: categoria?.empresaId,
})
